import { __awaiter, __generator } from "tslib";
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { logUserAction } from '@office-start/telemetry-service';
import { appendQuery } from '@office-start/url-parser-utility';
import { useCallback, useMemo } from 'react';
import { LoginHintParam, OneDriveManageStorageUrl } from '../constant';
import { useStorageErrorResources } from './useStorageErrorResources';
export var useManageStorage = function () {
    var storageResources = useStorageErrorResources();
    var context = useOfficeComponentContext().data;
    var oneDriveUrl = useMemo(function () {
        var url = OneDriveManageStorageUrl;
        if (context) {
            url = context.loginHint
                ? appendQuery(OneDriveManageStorageUrl, "".concat(LoginHintParam, "=").concat(context.loginHint))
                : OneDriveManageStorageUrl;
        }
        return url;
    }, [context]);
    var manageStorageClick = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            logUserAction({
                type: 'Click',
                id: 'StorageErrorManageStorage',
                area: 'Other',
                subArea: 'Other',
                result: 'Navigate',
                target: 'Other',
                eventName: 'StorageError_ManageStorage',
            });
            return [2 /*return*/];
        });
    }); }, []);
    return useMemo(function () {
        if (!storageResources)
            return undefined;
        var manageStorage = {
            link: oneDriveUrl,
            caption: storageResources.manageStorageText,
            description: storageResources.manageStorageText,
            onClick: manageStorageClick,
        };
        return manageStorage;
    }, [manageStorageClick, oneDriveUrl, storageResources]);
};
//# sourceMappingURL=useManageStorage.js.map